export default {
    callPhone: [
        {
            label: "cellcard",
            number: "085809809",
            type: 1
        },
        {
            label: "Smart",
            number: "0965550888",
            type: 2
        }, {
            label: "metfone",
            number: "0314500888",
            type: 3
        },
    ]
}